import { BaseSchemes, NodeEditor } from 'rete';
import { AreaPlugin } from 'rete-area-plugin';

import { Strategy } from './strategy';

/**
 * Stratégie en cas de clic.
 */
export class ClickStrategy<K> implements Strategy {
    /**
     * Constructeur.
     * @param editor : Editeur
     * @param area : Zone d'affichage.
     */
    constructor(
        private editor: NodeEditor<BaseSchemes>,
        private area: AreaPlugin<BaseSchemes, K>
    ) {}

    /**
     * Ajoute la capacité de créer des noeuds dans le designer à un élément Html.
     * @param element : Element Html qui pourra être cliqué pour créer un noeud.
     * @param create : Fonction appellée pour créer le noeud
     */
    addNodeCreationCapabilityToElement(element: HTMLElement, create: () => BaseSchemes['Node']): void {
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        element.addEventListener('click', async () => {
            const node = create();

            await this.editor.addNode(node);

            const viewportCenter = this.getViewportCenter();
            const view = this.area.nodeViews.get(node.id);

            if (!view) throw new Error('view');

            await view.translate(viewportCenter.x, viewportCenter.y);
        });
    }

    /**
     * Retourne la position au centre du viewport du designer.
     * @returns : Une position.
     */
    private getViewportCenter() {
        const { x, y, k } = this.area.area.transform;
        const box = this.area.container.getBoundingClientRect();
        const halfWidth = box.width / 2 / k;
        const halfHeight = box.height / 2 / k;

        return { x: halfWidth - x / k, y: halfHeight - y / k };
    }
}
